import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Collapse, Form, Space } from 'tdesign-react';
import Panel from '@/components/Panel';
import CodeMirrorLight from '@/components/CodeMirrorLight';
import { infos } from '..';

const { FormItem } = Form;

const { Panel: CollapsePanel } = Collapse;

export default function UninstallStep({ preStep, nextStep, cache }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (cache) {
      form.setFieldsValue(cache);
    }
  }, [cache, form]);

  const handleSubmit = ({ validateResult, fields }) => {
    if (validateResult === true) {
      nextStep(fields);
    }
  };

  return (
    <Form form={form} labelWidth={120} onSubmit={handleSubmit}>
      <Root
        footer={
          <Space size='small'>
            <Button variant='outline' onClick={preStep}>
              上一步
            </Button>
            <Button theme='primary' onClick={() => form.submit()}>
              下一步
            </Button>
          </Space>
        }
      >
        <Collapse borderless defaultExpandAll expandIconPlacement='right'>
          <CollapsePanel header={infos[0]}>
            <FormItem className='hide' name={['scriptCreateBOList', 0, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 0, 'launchStageEnum']}
              initialData='BEFORE_CONSTRUCT'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 0, 'scriptBusinessEnum']}
              initialData='UNINSTALL'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 0, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 0, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
          <CollapsePanel header={infos[1]}>
            <FormItem className='hide' name={['scriptCreateBOList', 1, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 1, 'launchStageEnum']}
              initialData='PULL_PACKAGE'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 1, 'scriptBusinessEnum']}
              initialData='UNINSTALL'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 1, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 1, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
          <CollapsePanel header={infos[2]}>
            <FormItem className='hide' name={['scriptCreateBOList', 2, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 2, 'launchStageEnum']}
              initialData='AFTER_CONSTRUCT'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 2, 'scriptBusinessEnum']}
              initialData='UNINSTALL'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 2, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 2, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
          <CollapsePanel header={infos[3]}>
            <FormItem className='hide' name={['scriptCreateBOList', 3, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 3, 'launchStageEnum']}
              initialData='LINK_CURRENT_PACKAGE'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 3, 'scriptBusinessEnum']}
              initialData='UNINSTALL'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 3, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 3, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
          <CollapsePanel header={infos[4]}>
            <FormItem className='hide' name={['scriptCreateBOList', 4, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 4, 'launchStageEnum']}
              initialData='BEFORE_PUBLISH'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 4, 'scriptBusinessEnum']}
              initialData='UNINSTALL'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 4, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 4, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
          <CollapsePanel header={infos[5]}>
            <FormItem className='hide' name={['scriptCreateBOList', 5, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 5, 'launchStageEnum']}
              initialData='AFTER_PUBLISH'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 5, 'scriptBusinessEnum']}
              initialData='UNINSTALL'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 5, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 5, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
        </Collapse>
      </Root>
    </Form>
  );
}

const Root = styled(Panel)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  .cm-editor {
    height: 300px;
  }
  .t-collapse-panel__header {
    height: 54px;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    background: #f7f8fa;
  }
  .t-collapse-panel__wrapper .t-collapse-panel__content {
    padding: 5px 0;
  }
`;
